angular.module('MktzapApp.Directives')

  .directive('overflowWhenAssigned', function () {
    return {
      restrict: 'AE',
      templateUrl: baseUrl + '/templates/directives/overflowWhenAssigned.html',
      scope: {
        modelField: '=',
        buttonTitle: '=',
        buttonHint: '='
      }
    };
  });
